// Import modules...
import "../css/app.css";

//@ts-expect-error
import dynamicImportPolyfill from "dynamic-import-polyfill";
import { createPinia } from "pinia";

// This needs to be done before any dynamic imports are used.
dynamicImportPolyfill.initialize();

import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
import { autoAnimatePlugin } from "@formkit/auto-animate/vue";
import { createHead } from "@unhead/vue";

import { createApp, h } from "vue";
import { createInertiaApp, Link } from "@inertiajs/vue3";
import mitt from "mitt";
import route from "ziggy-js";
import { createI18n } from "vue-i18n";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

import "highlight.js/styles/github.css";
import hljs from "highlight.js/lib/core";
import javascript from "highlight.js/lib/languages/javascript";
import hljsVuePlugin from "@highlightjs/vue-plugin";
hljs.registerLanguage("javascript", javascript);
import { z } from "zod";
import { makeZodI18nMap } from "zod-vue-i18n";

import en from "./lang/en.json";
import cs from "./lang/cs.json";

const emitter = mitt();

if (process.env.NODE_ENV === "production") {
    Bugsnag.start({
        apiKey: "4a54053d3e811919ff74c9b2d92a8538",
        plugins: [new BugsnagPluginVue()],
    });
}
const pinia = createPinia();

createInertiaApp({
    //@ts-expect-error
    resolve: (name) => {
        const pages = import.meta.glob("./Pages/**/*.vue", { eager: true });
        return pages[`./Pages/${name}.vue`];
    },
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) });

        let locale = "en";

        if (props.initialPage.props.locale === "cs-CZ") {
            locale = "cs";
        }

        const i18n = createI18n({
            legacy: false,

            locale: locale,

            pluralRules: {
                cs: function (choice) {
                    if (choice === 1) {
                        return 0;
                    }

                    if (choice > 1 && choice < 5) {
                        return 1;
                    }

                    return 2;
                },
            },

            messages: {
                en,
                cs,
            },
        });

        if (locale === "cs") {
            //@ts-expect-error
            z.setErrorMap(makeZodI18nMap(i18n));
        }

        if (process.env.NODE_ENV === "production") {
            const bugsnagVue = Bugsnag.getPlugin("vue");

            if (bugsnagVue) {
                app.use(bugsnagVue);
            }
        }

        const head = createHead();

        app.component("InertiaLink", Link);

        app.provide("emitter", emitter);
        app.config.globalProperties["route"] = route;
        app.use(plugin);
        app.use(i18n);
        app.use(hljsVuePlugin);
        app.use(autoAnimatePlugin);
        app.use(pinia);
        app.use(head);

        app.mount(el);
    },
    progress: {
        color: "#4B5563",
    },
});
